import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import SaveForLaterItem from './components/SaveForLaterItem'
import prevArrow from 'components/common/Carousel/assets/Prev-wo-background.svg'
import nextArrow from 'components/common/Carousel/assets/Next-wo-background.svg'
import prevArrowDisabled from 'components/common/Carousel/assets/PrevDisabled-wo-background.svg'
import nextArrowDisabled from 'components/common/Carousel/assets/NextDisabled-wo-background.svg'
import Mixin from 'components/common/Mixin'
import Carousel from 'components/common/Carousel'
import Link from 'components/common/Link/Link'
import {
  SAVE_FOR_LATER,
  TO_VIEW_YOUR_SAVED_ITEMS,
  ALL_SAVED_ITEMS,
  CREATE_ACCOUNT_URL,
  LOGIN_MOBILE_URL
} from './constants'

const SaveForLater = ({
  productsList,
  carouselConfig,
  vehicleName,
  isAuthorized,
  handleLoginMenu,
  saveForLaterItems,
  ...props
}) =>
  <Container>
    <InnerWrapper data-max-width data-max-width-padding>
      <TextWrapper>
        <Title>
          {`${SAVE_FOR_LATER} `}
          {`(${saveForLaterItems.length} ${saveForLaterItems.length > 1 ? 'items' : 'item'})`}
        </Title>

        {
          isAuthorized ?
            (<Text>
              {`${ALL_SAVED_ITEMS} `}<VehicleName>{`${vehicleName}.`}</VehicleName>
            </Text>) :
            (<Text>
              {TO_VIEW_YOUR_SAVED_ITEMS}
              <Media.Desktop>
                <CTALink onClick={ handleLoginMenu }> sign in </CTALink>
              </Media.Desktop>
              <Media.Mobile>
                <CTALink to={ LOGIN_MOBILE_URL }> sign in </CTALink>
              </Media.Mobile>
              or
              <CTALink to={ CREATE_ACCOUNT_URL }> create an account</CTALink>
              .
            </Text>)
        }
      </TextWrapper>

      <CarouselWrapper
        config={ carouselConfig }>
        {[...saveForLaterItems].reverse().map((item, index) => (
          <SaveForLaterItem key={ item.skuId } product={ item } { ...props } />
        ))}
      </CarouselWrapper>
    </InnerWrapper>
  </Container>

SaveForLater.propTypes = {
  carouselConfig: PropTypes.shape(),
  handleLoginMenu: PropTypes.func,
  isAuthorized: PropTypes.bool,
  productsList: PropTypes.arrayOf(PropTypes.shape()),
  saveForLaterItems: PropTypes.arrayOf(PropTypes.shape()),
  vehicleName: PropTypes.string
}

export default SaveForLater

const Container = styled.div`
  width: calc(100vw - 18px);
  max-width: 100vw;
  margin-top: 40px;
  margin-left: calc(50% - 50vw + 9px);
  padding: 42px 0 41px;
  background-color: ${Theme.colors.white_smoke};
`

const TextWrapper = styled.div`
  @media (max-width: 1279px) {
    margin: 0 0 0 16px;
  }
`

const Title = styled.h3`
  margin: 0 0 8px 0;
  line-height: 18px;
  font-size: 16px;
  font-weight: 700;
  transform: scale(1, 1.3);
`

const VehicleName = styled.span`
  font-size: 13px;
  font-weight: 600;
`

const Text = styled.p`
  margin: 0 0 42px 0;
  line-height: 15px;
  font-size: 13px;
`

const CTALink = styled(Link)`
  font-weight: 600;
`

const InnerWrapper = styled.div`
  ${Media.tablet`
    padding: 0 20px;
  `}
`

const CarouselWrapper = styled(Carousel)`
  margin: 0 -21px;

  @media (max-width: 1279px) {
    margin: 0;
  }

  .slick-track {
    margin-left: 0;

    @media (max-width: 500px) {
      margin-left: auto;
    }
  }

  .slick-prev {
    background: ${Theme.colors.white_smoke} url(${prevArrow}) center/contain no-repeat;
    ${Mixin.responsive('left', '-8px', '-32px')};
    z-index: 1;
  }

  .slick-arrow.slick-prev {
    left: -30px;

    @media (max-width: 1279px) {
      left: 0;
    }

    @media (max-width: 767px) {
      left: 10px;
    }
  }

  .slick-next {
    background: ${Theme.colors.white_smoke} url(${nextArrow}) center/contain no-repeat;
    ${Mixin.responsive('right', '-8px', '-32px')};
    z-index: 1;
  }

  .slick-arrow.slick-next {
    right: -30px;

    @media (max-width: 1279px) {
      right: 0;
    }

    @media (max-width: 767px) {
      right: 10px;
    }
  }

  .slick-prev.slick-disabled {
    background: ${Theme.colors.white_smoke} url(${prevArrowDisabled}) center/contain no-repeat;
    background-size: contain;
  }

  .slick-next.slick-disabled {
    background: ${Theme.colors.white_smoke} url(${nextArrowDisabled}) center/contain no-repeat;
    background-size: contain;
  }

  .slick-arrow + .slick-list {
    margin: 0;

    @media (max-width: 1279px) {
      margin: 0 40px;
    }
  }

  .slick-list {
    @media (max-width: 1023px) {
      margin: 0 6px;
    }

    @media (max-width: 767px) {
      margin: 0 0 0 6px;
    }

    @media (max-width: 479px) {
      margin: 0;
    }
  }
`
